(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scotland-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.header = this.sectionId
        ? document.getElementById('shopify-section-' + this.sectionId)
        : document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: 0 };
      this.scrollDeltaMin = 5;
      this.isHeaderHidden = false;

      this.onHeaderReady = this.onHeaderReady.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.setHeaderHeight();
      this.updateHeaderBounds();
      this.createObserver();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onHeaderReady);
      window.addEventListener('load', this.onHeaderReady);
      window.addEventListener('scotland-header:ready', this.onHeaderReady);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.header && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.onHeaderReady);
        this.resizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearchInstances = this.querySelectorAll('predictive-search');

      requestAnimationFrame(() => {
        requestAnimationFrame(this.onHeaderReady);
      });
    }

    onHeaderReady(event) {
      if (event && event.detail && event.detail.sectionId && event.detail.sectionId !== this.sectionId) {
        return;
      }
      this.setHeaderHeight();
      this.updateHeaderBounds();
    }

    setHeaderHeight() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      if (height > 0) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }

    updateHeaderBounds() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      if (height > 0) {
        this.headerBounds.bottom = height;
      }
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries) => {
        const intersectionRect = entries[0].intersectionRect;
        if (intersectionRect.bottom > 0) {
          this.headerBounds.top = intersectionRect.top;
          this.headerBounds.bottom = this.header.offsetHeight || intersectionRect.bottom;
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('load', this.onHeaderReady);
      window.removeEventListener('scotland-header:ready', this.onHeaderReady);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.scrollAnimationFrame) {
        cancelAnimationFrame(this.scrollAnimationFrame);
      }
    }

    onScroll() {
      if (!this.header || this.headerIsAlwaysSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isPredictiveSearchOpen()) return;

      if (this.scrollAnimationFrame) {
        cancelAnimationFrame(this.scrollAnimationFrame);
      }

      this.scrollAnimationFrame = requestAnimationFrame(() => {
        this.handleScroll(scrollTop);
      });
    }

    handleScroll(scrollTop) {
      const scrollDelta = scrollTop - this.currentScrollTop;
      const pastHeader = scrollTop > this.headerBounds.bottom;

      if (scrollDelta > this.scrollDeltaMin && pastHeader) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          this.hide();
        }
      } else if (scrollDelta < -this.scrollDeltaMin && pastHeader) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header || this.isHeaderHidden) return;
      this.isHeaderHidden = true;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header || !this.isHeaderHidden) return;
      this.isHeaderHidden = false;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.isHeaderHidden = false;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    isPredictiveSearchOpen() {
      return Array.from(this.predictiveSearchInstances || []).some((instance) => instance.isOpen);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
